import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { Reveal, SectionHeader } from "./Section";

export const faqs = [
  {
    q: "Pourquoi passer par un courtier plutôt qu'un assureur direct ?",
    a: "Un assureur ne vous propose que ses propres produits. OPTINA compare 30+ compagnies simultanément et négocie pour vous. Vous obtenez la meilleure offre du marché — pas juste ce qu'on veut bien vous vendre. Et c'est entièrement gratuit.",
  },
  {
    q: "Combien de compagnies comparez-vous ?",
    a: "Plus de 30 compagnies d'assurance et fournisseurs d'énergie partenaires.",
  },
  {
    q: "Puis-je résilier mon contrat en cours ?",
    a: "Oui. La loi Hamon et la loi Lemoine permettent la résiliation à tout moment après 1 an. Pour l'assurance emprunteur : résiliation possible immédiatement. Je gère toutes les démarches à votre place.",
  },
  {
    q: "Comment fonctionne l'assurance emprunteur ?",
    a: "Votre banque vous impose son assurance mais vous avez le droit d'en choisir une autre moins chère. Je compare et calcule vos économies potentielles sur la durée de votre prêt — sans changer de banque.",
  },
  {
    q: "Dans quelles zones intervenez-vous ?",
    a: "Partout en France, à distance par téléphone et visio. Bureaux à Paris (Champs-Élysées) et Aurillac (Cantal).",
  },
  {
    q: "Quel délai pour recevoir une réponse ?",
    a: "Je vous contacte sous 24 heures suivant votre demande.",
  },
  {
    q: "Puis-je changer d'assurance en cours de contrat ?",
    a: "Oui dans la majorité des cas. Je vérifie votre situation et gère toutes les démarches administratives à votre place.",
  },
];

export default function FaqSection({ heading = true }) {
  return (
    <section data-testid="faq-section" className="relative py-24 md:py-32 bg-brand-sand-2">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {heading && (
          <SectionHeader
            overline="Questions fréquentes"
            title="Tout ce que vous voulez savoir."
            subtitle="Les réponses aux questions les plus fréquentes. Si la vôtre n'y figure pas, écrivez-nous."
          />
        )}

        <Reveal className="mt-14 max-w-3xl">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`q${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-white rounded-xl border border-brand-border px-6 overflow-hidden"
              >
                <AccordionTrigger className="py-6 text-left font-serif text-lg md:text-xl tracking-tight text-brand-ink hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[15px] text-brand-ink/70 leading-relaxed font-light">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
